<template>
    <intelligent-inbox v-if="currentInbox === 'intelligent'"></intelligent-inbox>
    <vx-box
        v-else
        color="info"
        class="flex flex-col px-8 py-20 gap-6 items-center justify-center text-xl text-slate-700 h-80"
    >
        <font-awesome-icon widthAuto size="xl" :icon="faMessages"></font-awesome-icon>
        <span class="font-bold text-base">Select a Thread</span>
    </vx-box>
</template>
<script setup>
import { faMessages } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxBox } from '@voxie/frontend-components';
import { useRoute, useRouter } from 'vue-router';
import IntelligentInbox from '~/components/message-hub/intelligent-inbox/dashboard/IntelligentInboxDashboard.vue';
import { useMessageHub } from '~/components/message-hub/useMessageHub';

const route = useRoute();
const router = useRouter();
const { currentInbox } = useMessageHub();

if (!route.query.inbox) {
    router.replace({ name: 'message-hub.new-message' });
}
</script>
